import { render, staticRenderFns } from "./sportappoint.vue?vue&type=template&id=2a9dbb3c"
import script from "./sportappoint.vue?vue&type=script&lang=js"
export * from "./sportappoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports